import React from 'react';
import {ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line} from 'recharts';
// import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line} from 'recharts';
import Typography from '@material-ui/core/Typography';

const SimpleBarChart = props => {
  return (
    <div style={{
      width: "auto",
      marginTop: "15px",
      padding: "10px",
      border: "1px solid gray",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <Typography variant="body1" color="inherit">
        Admissões x Rescisões
      </Typography>
      <ComposedChart width={600} height={300} data={props.data}
          margin={{top: 5, right: 30, left: 20, bottom: 5}}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="mes" />
        <YAxis yAxisId="left"/>
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip/>
        <Legend />
        <Bar yAxisId="left" dataKey="admissoes" name="Admissões" fill="#8884d8" />
        <Bar yAxisId="left" dataKey="rescisoes" name="Rescisões" fill="#82ca9d" />
        <Line yAxisId="right" type="monotone" dataKey="empregados" name="Empregados em Folha" stroke="#82ca9d" />
      </ComposedChart>
    </div>
  );
}

export default SimpleBarChart
